<script setup lang="ts">
// The German blog, /de/blog: its own posts, not translations of the English ones
// (constants/blog.ts). German is its only language.
false && /*#__PURE__*/ defineI18nRoute({ locales: ['de'], paths: { de: '/blog' } })

definePageMeta({
  layout: 'blog',
  blogLocale: 'de',
})

const listing = await useBlogListing({ locale: 'de' })
</script>

<template>
  <BlogListing
    :posts="listing.posts.value"
    :page="listing.page"
    :page-count="listing.pageCount.value"
    :base-path="listing.basePath"
    :category="listing.category"
    :search-query="listing.searchQuery.value"
    locale="de"
    @search="listing.submitSearch"
  />
</template>
